var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { FiMinus, FiPlus } from 'react-icons/fi';
import colors from '../utils/colors';
import constants from '../utils/constants';
var ZoomButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n\n  border-color: ", ";\n    \n  color: ", "\n\n  float: right;\n  height: ", ";\n  width: ", ";\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  line-height: 16px;\n  padding: 4px 0 0 0;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:active {\n    ", "\n  }\n"], ["\n  background-color: ",
    ";\n\n  border-color: ", ";\n    \n  color: ", "\n\n  float: right;\n  height: ", ";\n  width: ", ";\n  font-size: 14px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  line-height: 16px;\n  padding: 4px 0 0 0;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:active {\n    ", "\n  }\n"])), function (props) {
    return props.isMinZoomLevel
        ? props.theme.supportingColorLight || colors.BG_GRAY_LIGHT
        : props.theme.primaryColorLighter || colors.BG_BLUE_LIGHT;
}, function (props) { return (props.isMinZoomLevel ? colors.GRAY : props.theme.primaryColor || colors.TURQUOISE); }, function (props) { return (props.isMinZoomLevel ? colors.GRAY : props.theme.primaryColor || colors.TURQUOISE); }, function (p) { return (p.mobile ? '26px' : '28px'); }, function (p) { return (p.mobile ? '40px' : '48px'); }, function (props) { return props.isMinZoomLevel && "border: 1px solid " + colors.GRAY + ";"; });
var Zoom = function (props) {
    var zoomLevel = props.zoomLevel, onZoom = props.onZoom, onMobile = props.onMobile;
    var zoomIn = function () {
        return onZoom(zoomLevel + constants.ZOOM_LEVEL_INCREMENT);
    };
    var zoomOut = function () {
        return onZoom(Math.max(zoomLevel - constants.ZOOM_LEVEL_INCREMENT, constants.ZOOM_LEVEL_MIN));
    };
    return (React.createElement("div", null,
        React.createElement(ZoomButton, { style: {
                borderBottomRightRadius: 15,
                borderTopRightRadius: 15,
            }, onClick: zoomIn, mobile: onMobile, isMinZoomLevel: false },
            React.createElement(FiPlus, { size: 15 })),
        React.createElement(ZoomButton, { style: {
                borderBottomLeftRadius: 15,
                borderTopLeftRadius: 15,
            }, onClick: zoomOut, mobile: onMobile, isMinZoomLevel: zoomLevel === constants.ZOOM_LEVEL_MIN },
            React.createElement(FiMinus, { size: 15 }))));
};
export default Zoom;
var templateObject_1;
//# sourceMappingURL=Zoom.js.map